import First from 'assets/illustrations/cooperations/first.png';
import Second from 'assets/illustrations/cooperations/second.svg';
import Third from 'assets/illustrations/cooperations/third.svg';

export const aboutUsCardsData = [
  {
    title: 'Наша команда',
    description:
      'Профессиональные разработчики, проектные менеджеры, бизнес-аналитики, системные аналитики и другие специалисты',
    img: First,
  },
  {
    title: 'Экспертность',
    description:
      'Мы применяем прозрачные процессы и гибкий подход. Разработали более 300 проектов в таких сферах, как финансовые технологии, телекоммуникация, электронная торговля и других',
    img: Second,
  },
  {
    title: 'Центры разработки',
    description:
      'Офисы компании находятся в крупных городах России, Казахстана и Беларуси. Такая география позволяет привлекать на проекты лучших в СНГ специалистов',
    img: Third,
  },
];
